import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const styles = `
.clube-page {
  min-height: 100vh;
  background-color: white;
}

.clube-hero {
  padding: 4rem 0 3rem;
  background: linear-gradient(to bottom, #f0f9f9, white);
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.clube-title {
  font-size: 3rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.clube-subtitle {
  text-align: center;
  color: #4A8080;
  max-width: 800px;
  margin: 0 auto 0rem;
  font-size: 1.25rem;
  line-height: 1.8;
}

.programas-section {
  padding: 5rem 0;
  background-color: white;
}

.section-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.section-subtitle {
  text-align: center;
  color: #6b7280;
  max-width: 800px;
  margin: 0 auto 4rem;
  font-size: 1.125rem;
  line-height: 1.6;
}

.programas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 3rem;
  margin-top: 3rem;
}

.programa-card {
  text-align: center;
  padding: 2rem;
}

.programa-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #e0f2f2;
}

.programa-icon svg {
  width: 40px;
  height: 40px;
  stroke: #5A9C9C;
  stroke-width: 2;
  fill: none;
}

.programa-card h3 {
  font-size: 1.5rem;
  color: #4A8080;
  margin-bottom: 1rem;
}

.programa-details {
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.programa-horario {
  font-style: italic;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

.programa-btn {
  padding: 0.75rem 2rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.programa-btn:hover {
  background-color: #3A6666;
}

.imagem-section {
  padding: 3rem 0;
  background-color: #f9fafb;
}

.imagem-container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.imagem-container img {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.oficinas-section {
  padding: 5rem 0;
  background-color: #e0f2f2;
}

.oficinas-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.oficinas-title {
  font-size: 2rem;
  color: #5A9C9C;
  margin-bottom: 1.5rem;
  font-weight: 300;
}

.oficinas-text {
  color: #4b5563;
  line-height: 1.8;
  font-size: 1.125rem;
  margin-bottom: 1rem;
}

.oficinas-image {
  margin-top: 2rem;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.oficinas-image img {
  width: 100%;
  height: auto;
  display: block;
}

.festas-section {
  padding: 5rem 0;
  background-color: white;
}

.festas-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.festas-title {
  font-size: 2rem;
  color: #5A9C9C;
  margin-bottom: 1rem;
  font-weight: 300;
}

.festas-subtitle {
  color: #4A8080;
  font-size: 1.25rem;
  margin-bottom: 2rem;
}

.festas-text {
  color: #4b5563;
  line-height: 1.8;
  font-size: 1.125rem;
  margin-bottom: 1rem;
}

.festas-highlight {
  background-color: #f0f9f9;
  padding: 2rem;
  border-radius: 0.5rem;
  border-left: 4px solid #5A9C9C;
  margin: 2rem 0;
}

.festas-highlight p {
  color: #4A8080;
  font-size: 1.125rem;
  line-height: 1.6;
  margin: 0.5rem 0;
}

.festas-btn {
  padding: 1rem 3rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 2rem;
}

.festas-btn:hover {
  background-color: #3A6666;
}

@media (max-width: 768px) {
  .clube-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .programas-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .oficinas-title,
  .festas-title {
    font-size: 1.75rem;
  }
}
`;

export default function ClubeBarcoPage() {
  return (
    <>
      <style>{styles}</style>
      <div className="clube-page">
        <section className="clube-hero">
          <div className="container">
            <h1 className="clube-title">PROGRAMAS DISPONÍVEIS</h1>
            <p className="clube-subtitle">
              De Manhã ou de Tarde e ao Fim de Semana
            </p>
          </div>
        </section>

        <section className="programas-section">
          <div className="container">
            <div className="programas-grid">
              <div className="programa-card">
                <div className="programa-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5"/>
                    <path d="M2 12l10 5 10-5"/>
                  </svg>
                </div>
                <h3>TEMPO LIVRE</h3>
                <p className="programa-details">
                  Espaço Tempo Livre<br/>
                  de 2ª a 6ª feira<br/>
                  das 10h às 12h e das 15h às 18h
                </p>
                <p className="programa-horario">
                  Deixe os seus filhos terem uma experiências com liberdade total para 
                  brincarem e aprenderem com muita imaginação.
                </p>
                <Link to="/agendamento" className="programa-btn">+ info</Link>
              </div>

              <div className="programa-card">
                <div className="programa-icon">
                  <svg viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                  </svg>
                </div>
                <h3>OFICINAS MÃOS À OBRA</h3>
                <p className="programa-details">
                  Oficina Criativa com atividades regulares e programadas durante a semana.
                </p>
                <p className="programa-horario">
                  de 2ª a 6ª das 18:30h às 19:30h
                </p>
                <div style={{ textAlign: 'center', margin: '1.5rem 0' }}>
                  <img 
                    src="/assets/image12.png" 
                    alt="Oficinas Mãos à Obra" 
                    style={{ 
                      maxWidth: '280px', 
                      width: '100%', 
                      borderRadius: '0.5rem',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      marginLeft:'18px'
                    }}
                  />
                </div>
              </div>

              <div className="programa-card">
                <div className="programa-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
                <h3>FESTAS DE ANIVERSÁRIO</h3>
                <p className="programa-details">
                  Vamos festejar!
                </p>
                <p className="programa-horario">
                  Disponibilizamos festas de aniversário para as crianças se divertirem com os seus amigos.
                  <br/><br/>
                  Possibilidade de fazer festas únicas com temas à escolha dos seus filhos.
                </p>
                <Link to='/festas-aniversario' className="programa-btn">+ info</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}